import { render, staticRenderFns } from "./index-shop.vue?vue&type=template&id=77d75aea&scoped=true&"
import script from "./index-shop.vue?vue&type=script&lang=js&"
export * from "./index-shop.vue?vue&type=script&lang=js&"
import style0 from "./index-shop.vue?vue&type=style&index=0&id=77d75aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d75aea",
  null
  
)

export default component.exports